module.exports = __webpack_public_path__ + "resources/e70e315b98145495760f797e802cbed1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/equipment.png
// module id = 197
// module chunks = 0